


















































































































import AbpBase from '../../../lib/abpbase'
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import {QueryStandingBookDetail,
        QuerySupplier,CreateStockIn,
        QueryConStockIn,QueryStockInDetailById,
        EditStockInCheck,EditStockInCharge,
        DeleteStockIn
} from '../../../api/consumablesStock'

import {GetConsumables,GetUtcodeList,GetGhscodeList} from '../../../api/specialDictionary'
import {GetAutCodeList} from '../../../api/basicDictionary'
import Util from '../../../lib/util'
import u from 'underscore'

//单据打印组件
import print from '../../../components/print/stockBills.vue'

@Component({
    components:{print}
})
export default class StorageIn extends AbpBase {

    printShow:Boolean = false;
    printData:any = {
        list:[],
        title:[
            '单据编码',
            '耗材名称',
            '生产厂家',
            '数量',
            '单位',
            '进价',
            '进价总额',
            '零价',
            '零价总额',
            '批号',
            '有效日期',
            '入库人',
            '入库日期',
        ]
    }

    list:any = []//table数据源
    tabList:any = []//选择table数据源

	table = {
		loading:false,
		tabLoading:false,
    }
     //远程搜索加载
    remoteloading:Boolean = true;
    //点击选择or不选中
    flag:Boolean = true;

    //按钮装态
    deleteBillsShow:Boolean = false
    ztShow:Boolean = false
    checkShow:Boolean = true
    saveShow:Boolean = true

    //当前选择行状态 （暂存可新增，核对不可）
    rowStatus:Boolean = false;
    //核对loding
    checkLoding:Boolean = false;
    //暂存loding
    tsLoding:Boolean = false;
    //记账loding
    saveLoding:Boolean = false;
    //删除loding
    deleteLoding:Boolean = false;

    receiptNo:Number = Date.now();
    //数值累计判断
    reducePrice:Boolean = false;
    //当前选择行
    rowActive:any = {}

    model:any = {
        consumableId:null,
        validityPeriod:null,
        quantity:null,
        unit:null,
        batchNo:null,
        purchasePrice:null,
        zeroPrice:null,
        supplierId:null,
    }

    created() {
        // this.getconList();
        // this.getMeteringList();
        this.querySupplier();
        this.getTabList()
    }
    //选择框数据
    unitOptions:any=[]
    conOptions:any=[]
    conList:any=[]
    supplierOptions:any=[]
    //获取tab 数据
    getTabList(){
        this.queryconStorageStockIn()
    }
    async queryconStorageStockIn(){
        this.table.tabLoading = true
		let payload = {
			MaxResultCount:100,
			SkipCount:1
		}
        let response = await QueryConStockIn(payload)
		this.tabList = response.data.items
        this.table.tabLoading = false
        //默认选择第一条
        if(this.tabList.length>0) {
            this.tabList[0]._highlight = true;
            this.rowActive = this.tabList[0];
            this.deleteBillsShow = false
            this.getStatus(this.tabList[0].stockInStatus)
            this.getTalDetail(this.tabList[0].id)
             //单据号
            this.receiptNo = Number(this.tabList[0].receiptNo)
            //带出供货商
            this.model.supplierId = this.tabList[0].supplierId

        }else{
            this.rowActive = {}
            this.ztShow = false
            this.checkShow = true
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = true
        }
    }
    getStatus(type:any){
        //按钮status
        if(type == 1){
            this.ztShow = false
            this.checkShow = false
            this.saveShow = true
            this.rowStatus = false
            this.deleteBillsShow = false

        }else{
            this.ztShow = true
            this.checkShow = true
            this.saveShow = false
            this.deleteBillsShow = false
            this.rowStatus = true
        }

    }
    //获取详情数据
    async getTalDetail(id:any){
         let data = {
            stockInId:id,
            PageSize:100,
            Page:1
        }
        let res  = await QueryStockInDetailById(data)
        console.log(res)
        this.list = res.data.consumableStockInDetailResult.items
        this.reducePrice = true;

        //总额计算
        let batchPurchasePrice = 0;
        let batchZeroPrice = 0;
        res.data.consumableStockInDetailResult.items.forEach((item:any) =>{
            batchPurchasePrice+=item.batchPurchasePrice;
            batchZeroPrice+=item.batchZeroPrice;
        });
        let batchZeroPriceValues = res.data.consumableStockInDetailResult.items.map((item:any) => Number(item.batchZeroPrice));
        this.list.push({
            zj:true,
            receiptNo:'总价',
            batchPurchasePrice:batchPurchasePrice,
            batchZeroPrice:batchZeroPrice,
        })

    }
    //选择耗材信息
    conActiveinfo:any = {};
    //表格高度
    get tableHeight(){
        return window.innerHeight-580
    }
    //登陆人
    get staffName(){
        return this.$store.state.session.user?this.$store.state.session.user.name:''
    }
    //耗材
    async remoteMethodCon(query:any){
        let str = (this.$refs['setSelect'] as any).$data.query;
        if (str) {
        //赋值为空
            (this.$refs['setSelect'] as any).query = ''
        }
        this.conOptions = [];
		if (query !== '') {
			this.remoteloading = true;
            let data = {
                queryString:query,
                status:1,
                MaxResultCount:1000,
                SkipCount:1
            }
            let res = await GetConsumables(data)
            this.conList = res.items
            setTimeout(() => {
                this.remoteloading = false;
                const list = res.items.map((item:any) => {
                    return {
                        id: item.id,
                        conName: item.conName
                    };
                });
                this.conOptions = list
            }, 200);

        } else {
            this.conOptions = [];
        }
	}
	// async getconList(){
    //     let data = {
    //         queryString:'',
	// 		status:0,
	// 		pageSize:1000,
	// 		Page:1
    //     }
    //     let res = await QueryConsumables(data)
    //     this.conOptions = res.data.items
    //     console.log(this.conOptions)
    // }
    //单位
    // async getMeteringList(){
    //     let data = {
    //         QueryString:'',
    //         PageSize:1000,
    //         Page:1
    //     }
    //     let res = await GetMeteringList(data)
    //     this.unitOptions = res.data.items

    // }
    //供货商
    async querySupplier(){
        let data = {
            QueryString:'',
            MaxResultCount:1000,
            SkipCount:1
        }
        let res = await GetGhscodeList(data)
        this.supplierOptions = res.items
    }
    //耗材信息带出
    conChange(){
        if(this.model.consumableId){
            this.conList.forEach((item:any)=>{
                if(item.id==this.model.consumableId){
                    this.conActiveinfo = item;
                    //单位选项
                    this.unitOptions = []
                    this.unitOptions.push({
                        id:Number(item.minUnit),
                        meterName:item.minUnitName
                    })
                    this.model.unit = Number(item.minUnit)
                    this.model.purchasePrice = item.purPriceNew
                    this.model.zeroPrice = item.price
                }
            })
        }
    }
    //数据导出
    exportData(){
        (this.$refs.table as any).exportCsv({
            filename: 'The original data'
        })
    }
     //清除高亮项
    clearCurrentRow(callback:any){
        (this.$refs.tabTable as any).clearCurrentRow()
        //重新生成单据号
        this.receiptNo = Date.now()
        //供货商 置空
        this.model.supplierId = 0;

        this.rowActive = {};
        this.list = []
        this.ztShow = false
        this.checkShow = true
        this.saveShow = true
        this.deleteBillsShow = true
        this.rowStatus = false
        callback()
    }
    //点击清除高亮
    firstTabChage:Boolean = true //(默认加载第一条。取消选择不会触发tabChange事件。记录没触发tabChange之前的状态)
    clecarActive(row:any){
        let indexs;
        this.tabList.forEach((item:any,index:any) => {
            if(item.id == row.id){
                indexs = index;
            }
        });
        if(this.rowActive.id == row.id && this.firstTabChage){
            this.clearCurrentRow(function(){})
        }
        if(this.flag){
            // this.tabList[indexs]._highlight = true;
            this.flag = false
            // this.deleteBillsShow = false;
        }else{
            this.clearCurrentRow(function(){})
            this.flag = true
        }
    }
    //表格添加
    push(){
        let that = this;
        (this.$refs.ruleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                //清空表格尾部
                if(this.reducePrice){
                    this.list.pop()
                }
                this.list.push({
                   receiptNo:this.receiptNo,
                   consumableName:this.conActiveinfo.conName,
                   quantity:this.model.quantity,
                   unit:this.model.unit,
                   consumableId:this.model.consumableId,
                   unitName: u.find(that.unitOptions, function(value:any, key:any, list:any){return list[key].id == that.model.unit}).meterName,
                   batchNo:this.model.batchNo,
                   purchasePrice:this.model.purchasePrice,
                   zeroPrice:this.model.zeroPrice,
                   batchPurchasePrice:this.model.purchasePrice*this.model.quantity,
                   batchZeroPrice:this.model.zeroPrice*this.model.quantity,
                   manufacturer:this.conActiveinfo.manuName,
                   validityPeriod:Util.dateConversion(this.model.validityPeriod),
                   staffName:this.staffName,
                   now:Util.dateConversion(new Date())
                })
                let values1 = this.list.map((item:any) => Number(item.batchPurchasePrice));
                let values2 = this.list.map((item:any) => Number(item.batchZeroPrice));
                let batchPurchasePrice = u.reduce(values1, function(memo:any, num:any){ return memo + num; }, 0);
                let batchZeroPrice = u.reduce(values2, function(memo:any, num:any){ return memo + num; }, 0);
                //合计计算

                this.list.push({
                    zj:true,
                    receiptNo:'总价',
                    batchPurchasePrice:batchPurchasePrice,
                    batchZeroPrice:batchZeroPrice,
                })
                this.reducePrice = true;
                this.clear()
            }
        })
    }
    //暂存
    Ts(){
        if(this.list.length<1){
            this.$Message.info('请选择耗材');
            return false
        }
        if(!this.model.supplierId){
            this.$Message.info('请选择供货商');
            return false
        }
        //去掉合计
        this.list.pop()
        let data = {
            receiptNo:this.receiptNo,
            stockInId:this.rowActive.id || 0,
            supplierId:this.model.supplierId,
            conStockInInputDetailDto:this.list,
        }
        this.createStockIn(data)
    }
    async createStockIn(data:any){
        this.tsLoding = true;
        let res = await CreateStockIn(data)
        if(res.code==2000){
            //
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
        }else{
            //
        }
        this.tsLoding = false;
    }
    //核对
    async check(){
        let data = {
            stockInDel:[{stockInId:this.rowActive.id}]
        }
        this.checkLoding = true;

        let res = await EditStockInCheck(data)
        if(res.code==2000){
            //
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()

        }else{
            //
        }
        this.checkLoding = false;
    }
    //记账
    async save(){
        let data = {
            stockInDel:[{stockInId:this.rowActive.id}]
        }
        this.saveLoding = true;
        let res = await EditStockInCharge(data)
        if(res.code==2000){
            this.printData.list = []
            this.list.forEach((item:any,index:any)=>{
                this.printData.list.push([
                    item.receiptNo,
                    item.consumableName,
                    item.manufacturer,
                    item.quantity,
                    item.unitName,
                    item.purchasePrice,
                    item.batchPurchasePrice,
                    item.zeroPrice,
                    item.batchZeroPrice,
                    item.batchNo,
                    Util.formatTime(item.validityPeriod),
                    item.staffName,
                    index == this.list.length-1 ?'':Util.dateConversion(new Date()),
                ])
            })
            this.printShow = true


            //
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            // document.getElementById('pr').click()
        }else{
            //
        }
        this.saveLoding = false;
    }
    //打印完成回调
    printBack(){
        this.printShow = false;
    }
    //删除单据
    async deleteBills(){
        this.$Modal.confirm({
			title: '确认删除',
			content: '',
			onOk: () => {
                this.deleteLoding = true;
				let data = {
                    stockInDel:[{stockInId:this.rowActive.id}]
                }
				this.deleteStockIn(data)
			},
			onCancel: () => {

			}
		})


    }
    async deleteStockIn(data:any){
        let res = await DeleteStockIn(data)
        if(res.code==2000){
            //
            this.list = [];
            this.receiptNo = Date.now()
            this.getTabList()
            this.deleteLoding = false;
        }else{
            //
            this.deleteLoding = false;
        }
    }
    clear(){
		(this.$refs.ruleForm as any).resetFields();
    }
    delete(index:any){
        this.list.splice(index, 1);
        if(this.list.length==1){
            this.list.splice(0, 1);
        }
    }
    //tab选择
    tabChange(currentRow:any,oldCurrentRow:any){
        this.firstTabChage = false;
        // console.log(currentRow)
        if(currentRow){
            this.rowActive = currentRow
            //带出单据号
            this.receiptNo = Number(currentRow.receiptNo)
            //带出供货商
            this.model.supplierId = currentRow.supplierId
            this.getStatus(currentRow.stockInStatus)
            this.getTalDetail(currentRow.id)
            if(currentRow != oldCurrentRow){
                this.flag = true
            }
        }
    }


	columns = [{
		title: '单据编码',
        key: 'receiptNo',
        width:160,
	},{
		title: "耗材名称",
        key: 'consumableName',
        width:130,
	},{
		title: "生产厂家",
		key: 'manufacturer',
        width:130,
	},{
		title: "数量",
		key: 'quantity',
        width:130,
	},{
		title: "单位",
		key: 'unitName',
        width:130,
	},{
		title: "进价",
		key: 'purchasePrice',
        width:130,
	},{
		title: "进价总额",
		key: 'batchPurchasePrice',
        width:130,
	},{
		title: "零价",
		key: 'zeroPrice',
        width:130,
	},{
		title: "零价总额",
		key: 'batchZeroPrice',
        width:130,
	},{
		title: "批号",
		key: 'batchNo',
        width:130,
	},{
		title: "有效日期",
		key: 'validityPeriod',
        width:130,
        render: (h: any, params: any) => {
            return h('span',Util.formatTime(params.row.validityPeriod))
        }
	},{
		title: "入库人",
		key: 'staffName',
        width:130,
	},{
		title: "入库日期",
		key: 'now',
        width:130,
        render: (h: any, params: any) => {
           if(params.row.now){
               return h('span',Util.formatTime(params.row.now))
           }else{
               return h('span',Util.formatTime(params.row.validityPeriod))
           }
        }
	},{title: this.L('Actions'),
        key: 'Actions',
        fixed: "right",
        width:80,
		render: (h: any, params: any) => {
			if(!params.row.zj){
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small'
                        },
                        on: {
                            click: () => {
                                this.delete(params.add)
                            }
                        }
                    }, this.L('Delete'))
                ])
            }
		}
    }]
    tabColumns=[{
		title: '单据编码',
        key: 'receiptNo',
	},{
		title: "入库日期",
        key: 'stockInDate',

	},{
		title: "操作员",
        key: 'staffName',
	},{
		title: "状态",
        key: 'stockInStatus',
        render:(h: any, params: any) => {
            return h('span',params.row.stockInStatus == 1?"暂存":"核对")
        }
    }]
    rules={
        consumableId:[{required: true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        unit:[{required:true,message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        batchNo:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
        quantity:[{required: true,message:this.L('FieldIsRequired'),type:'number', trigger: 'blur'}],
        validityPeriod:[{required: true,message:this.L('FieldIsRequired'),type:'date',trigger: 'blur'}],
        purchasePrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        zeroPrice:[ { required: true, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        // supplierId:[ { required: false, message:this.L('FieldIsRequired'),type:'number',trigger: 'blur'}],
        receiptNo:[ { required: false, message:this.L('FieldIsRequired'),trigger: 'blur'}],

    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/consumablesStock/storageIn/index.vue